import { Divider, Stack, Typography } from '@mui/material'
import numeral from 'numeral'
import { Icons } from 'utoniq-ui'

import { ItemMetadataDetail, Maybe } from '@/clients/utoniq-core/schema'
import { ResaleCategory } from '@/components/organisms/item/ResaleCategory'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type ExhibitionContentProps = {
  title?: string
  skuName?: string
  price?: number
  formattedPrice?: string
  unusedCount: number
  isResaleAvailable: boolean
  metadata?: Maybe<ItemMetadataDetail>
}

export const ExhibitionContent: Organism<ExhibitionContentProps> = ({
  title,
  skuName,
  price = 0,
  formattedPrice = 0,
  isResaleAvailable,
  unusedCount,
  metadata,
}) => {
  const { t } = useTranslation('resaleCreate')
  return (
    <OrganismFrame>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ bgcolor: 'grey.50', py: 1, px: 2 }}
      >
        <Icons.Post fontSize="small" sx={{ color: 'grey.600' }} />
        <Typography variant="h6" color="text.secondary">
          {t('exhibitionContent')}
        </Typography>
      </Stack>
      <Stack spacing={2} sx={{ pt: 3, pb: 5 }}>
        <Stack spacing={1}>
          <Typography variant="h5">{title}</Typography>
          {!!skuName && <Typography variant="subtitle1">{skuName}</Typography>}
        </Stack>
        <ResaleCategory isResaleAvailable={isResaleAvailable} />
      </Stack>
      <Stack sx={{ pb: 5 }}>
        <Typography variant="body2">{metadata?.ticket?.description}</Typography>
      </Stack>
      <Divider />
      <Stack sx={{ pt: 5, pb: 7 }} spacing={4}>
        <Stack spacing={1}>
          <Typography variant="subtitle1">{t('ticketPrice')}</Typography>
          <Typography variant="body2">
            ¥{formattedPrice}/1{t('perSheet')}
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="subtitle1">{t('holdingQuantity')}</Typography>
          <Typography variant="body2">
            {unusedCount}
            {t('sheet')}
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="subtitle1">{t('totalAmount')}</Typography>
          <Typography variant="body2">
            ¥{numeral(unusedCount * price).format('0,0')}
          </Typography>
        </Stack>
      </Stack>
    </OrganismFrame>
  )
}
